import React, { useState } from 'react';
import Xmark from "../../assets/images/smallxmark.png";
import { notesTop, notesBottom } from "./notes";
import "./addNotes.css";
import { useLocation, useNavigate } from "react-router";
import { useSelector, useDispatch } from 'react-redux'
import { fetchCurrentState } from '../../redux/features/customerViewSlice';
import { addNotes, fetchCurrentNotes } from '../../redux/features/addNotesSlice';
// import {
//   fetchCurrentState,
//   getTripData,
// } from '../../redux/features/customerViewSlice'


export default function AddNotes() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const addNotesCategory = (item) => {
    const type = location?.state?.type
    let noteItem = {...item} 
    noteItem.note = ''
    noteItem.type = type
    noteItem.isEdit = true
    dispatch(
      addNotes(noteItem),
    )
    navigate("../recenttrip/trip/create-trip/overview", {state:{type:type}, replace: true})
  }

  const handleLocationType = () => {
    const type = location?.state?.type
    navigate("../recenttrip/trip/create-trip/overview", {state:{type:type}, replace: true})
  }

  return (
    <div className='addNotes-content'>
         <div className="addNotes-top">
                <p style={{fontSize:"20px", fontWeight: "700", margin: "10px 0"}}>Add notes</p>
                <img src={Xmark} alt="close" onClick={handleLocationType}/>
          </div>
          <p style={{ fontSize: "15px", marginTop: "0" }}>What are you adding on the note?</p>
          <div className='notes-items-top'>
          {
              notesTop.map(item => (
                      <div key={item.id} className='note-item' onClick={() => addNotesCategory(item)}>
                          <img src={item.img} alt="" /><span>{item.text}</span>
                      </div>
                 
              ))
          }
          </div>
          <div style={{borderBottom:"1px solid #CDD0E1", margin:"1rem 0"}}></div>
          <div className='notes-items-top'>
          {
              notesBottom.map(item => (
                      <div key={item.id} className='note-item' onClick={() => addNotesCategory(item)}>
                          <img src={item.img} alt="" /><span>{item.text}</span>
                      </div>
                 
              ))
          }
          </div>
         
    </div>
  )
}
